import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { useRouteParam } from '@hooks/params';

import {
  insurancePolicyUserFetch,
  InsurancePolicyUserFetchPayload,
  insurancePolicyUserHealthPolicyBenefitLimitsFetch,
  InsurancePolicyUserHealthPolicyBenefitLimitsFetchPayload,
} from './action';
import { selectInsurancePolicyUserDetails } from './selector';

export const useInsurancePolicyUserFetch = () => {
  const dispatch = useDispatch();
  const insurancePolicyUserId = Number(useRouteParam('insurancePolicyUserId'));
  const { policyUser, healthPolicyBenefitLimitsWithAccumulatedPaidAmounts } = useSelector(selectInsurancePolicyUserDetails);

  useEffect(() => {
    const payload: InsurancePolicyUserFetchPayload = { id: insurancePolicyUserId };
    dispatch(insurancePolicyUserFetch(payload));
  }, [insurancePolicyUserId, dispatch]);

  useEffect(() => {
    const payload: InsurancePolicyUserHealthPolicyBenefitLimitsFetchPayload = { id: insurancePolicyUserId };
    dispatch(insurancePolicyUserHealthPolicyBenefitLimitsFetch(payload));
  }, [insurancePolicyUserId, dispatch]);

  return { policyUser, healthPolicyBenefitLimitsWithAccumulatedPaidAmounts };
};
